export const getDevicePixelRatio = (devicePixelRatio, isWebBrowser) => {
  if (isWebBrowser) return 4
  if (devicePixelRatio === 3) return 1
  if (devicePixelRatio === 2) return 1
  if (devicePixelRatio < 2) return 4
  return devicePixelRatio * 2
}

const parseViewBox = (svgString) => {
  const match = svgString.match(/viewBox="0\s+0\s+([\d.]+)\s+([\d.]+)"/)
  if (match) return { w: parseFloat(match[1]), h: parseFloat(match[2]) }
  return { w: 612, h: 441 }
}

export const SVGToBase64 = (rawSVG, isWebBrowser, basicPlanCode) => {
  //can't update unescape because effect old svg graph
  const url = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(rawSVG)))
  const img = new Image()

  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const { w, h } = parseViewBox(rawSVG)
    const scale = getDevicePixelRatio(window.devicePixelRatio, isWebBrowser)

    img.onload = () => {
      if (!canvas) {
        return reject()
      }
      canvas.width = w * scale
      canvas.height = h * scale
      ctx.scale(scale, scale)
      ctx.drawImage(img, 0, 0, w, h)
      resolve(canvas.toDataURL())
      canvas = null
    }
    img.onerror = () => reject('error')

    img.src = url
  })
}

export const base64ToBlob = (base64) =>
  new Promise((resolve) => {
    const raw = window.atob(base64)
    const rawLength = raw.length
    const array = new Uint8Array(new ArrayBuffer(rawLength))

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i)
    }

    return resolve(new Blob([array.buffer], { type: 'application/pdf' }))
  })

export const svgStringToBase64 = (svgString) => {
  //can't update unescape because effect old svg graph
  const url = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)))
  const img = new Image()

  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.style.width = '100%'
    canvas.style.height = '100%'

    img.src = url
    img.onload = () => {
      if (!canvas) {
        return reject()
      }
      const scale = window.devicePixelRatio
      canvas.width = img.width * scale
      canvas.height = img.height * scale
      ctx.scale(scale, scale)

      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL())
      canvas = null
    }
    img.onerror = (e) => reject(`error: ${e}`)
  })
}
